import ajax from '../common/js/ajax.js' //引用封装好的axios
const api = {} //新建一个api对象 里面放开发时使用的一系列接口
//登录接口
api.login = (params, data) => ajax('user/login', params, 'post')
//数据总览
api.dataView = (params, data) => ajax('largerScreen/dataView', {}, 'get')

//绿色效益
api.greenBenefit = (params, data) => ajax('largerScreen/greenBenefit', {}, 'get')


//派工情况
api.workOrderList = (params, data) => ajax('largerScreen/workOrderList', params, 'post')


//告警信息
api.alarmInformationList = (params, data) => ajax('largerScreen/alarmInformationList', params, 'post')

//充电桩使用情况
api.useCondition = (params, data) => ajax('largerScreen/useCondition', params, 'post')


//营收情况
api.revenueSituation = (params, data) => ajax('largerScreen/revenueSituation', params, 'get')

//加盟情况
api.joinSituation = (params, data) => ajax('largerScreen/joinSituation', params, 'get')

//营收结构
api.revenueStructure = (params, data) => ajax('largerScreen/revenueStructure', params, 'get')

//营收结构
api.listCommunitySiteByCommunityId = (params, data) => ajax('largerScreen/listCommunitySiteByCommunityId', {}, 'get')


//营收结构
api.listCommunityEquipmentBySelective = (params, data) => ajax('largerScreen/listCommunityEquipmentBySelective', params, 'post')


export default api //将新建好的api对象模块指定默认输出
